import React from 'react';

// Make hatTarget 'ref="hatTarget"'
// Add '.fill' to all body elements
// Add '.fill--face' to nose

class HeadHOC extends React.Component {
	componentDidMount() {
		this.props.getHatTargetCoords(this.refs.hatTarget);
	}
}

export default class Heads extends HeadHOC {
	render() {
		return (
			<g>
				<circle ref="hatTarget" cx="205.6381073" cy="135.2619781" r="0" />
				<path className="fill" fill="#F7EDE8" d="M206.63898,245.34312c29.90564,0.99332,52.01013-20.01332,63.60568-77.88104
					c0,0-7.60019-50.86475-63.60655-50.86475c-56.00569,0-63.60591,50.86475-63.60591,50.86475
					c11.59558,57.86772,33.70006,78.87436,63.6057,77.88104H206.63898z" />
				<g className="tongue">
					<path fill="#B45A60" d="M206.80154,204.31487c14.85411,0,21.00183-24.62981,21.00183-24.62981s-6.14772-4.39352-21.00182-4.39352
						c-14.85411,0-21.00183,4.39352-21.00183,4.39352S191.94745,204.31487,206.80154,204.31487z" />
					<path fill="#FC5959" d="M206.80167,196.96463c0,0,6.00156-0.33357,7.61101,0.85893s2.73509,3.88394,3.64272,5.82573
						c0.87399,1.94197,1.51778,3.88376,1.96617,5.82573c0.45567,1.94199,0.6993,3.88376,0.6731,5.82574
						c-0.0392,1.94197-0.26118,3.88376-1.13927,5.82573c-1.16982,2.52538-4.06149,4.67981-8.00044,5.5312
						c-1.20993,0.26147-3.54944,0.38599-4.7536,0.3862c-1.20416-0.00021-3.54367-0.12473-4.7536-0.3862
						c-3.93895-0.85139-6.83063-3.00583-8.00046-5.5312c-0.87807-1.94197-1.10007-3.88376-1.13927-5.82573
						c-0.0262-1.94199,0.21744-3.88376,0.67311-5.82574c0.44839-1.94197,1.09218-3.88376,1.96617-5.82573
						c0.90762-1.94179,2.03326-4.63322,3.64272-5.82573S206.80103,196.96463,206.80167,196.96463z" />
				</g>
				<path className="fill" fill="#F7EDE8" d="M206.63844,147.29478c19.27068,0,41.6738,8.33925,37.88759,44.45351
					c-3.08282,29.40503-17.98793,36.12108-37.72501,36.12108s-34.96736-6.71602-38.05019-36.12108
					C164.96463,155.63403,187.36775,147.29478,206.63844,147.29478z" />
				<path className="fill--face" fill="#1A1A1A" d="M206.63844,205.06024c-4.71431,0-8.01779,0.91878-9.51407,2.79565
					c-1.49629,1.87688-2.09663,6.32716-0.16583,9.95689c1.68944,3.17599,5.01839,5.21803,8.28746,5.67894
					c0.46701,0.06584,2.25238,0.0704,2.68637,0.01341c3.30052-0.43341,6.67953-2.48445,8.38596-5.69235
					c1.9308-3.62973,1.33046-8.08002-0.16583-9.95689C214.65622,205.97902,211.35274,205.06024,206.63844,205.06024z" />
				<path className="fill fill--alt" fill="#B78A76" d="M203.69295,151.64412c-1.9566-5.3313-6.77899-9.98999-14.5545-10.66772
					c-27.58606-2.4043-41.44598,9.99805-46.05585,26.11914c-0.04382,0.24561-0.06439,0.38062-0.06439,0.38062
					c3.73126,18.62085,8.55658,33.40552,14.37396,44.88794l0.46184,0.89058c2.42152,5.65628,21.52602,12.40727,37.50856-15.12544
					C201.30428,187.89363,208.54878,164.87532,203.69295,151.64412z" />
				<g className="ear ear--right">
					<path className="fill fill--alt" fill="#B78A76" d="M239.64149,132.53613c19.77919,38.45963,13.67339,84.05106,26.67735,87.68307
						c9.88467,2.7608,49.68677-58.26537,31.83566-76.82358c-3.88922-4.04327-32.38397-22.82735-38.86493-27.01538
						C247.57631,108.81104,228.69728,111.25569,239.64149,132.53613z" />
				</g>
				<g className="ear ear--left">
					<path className="fill fill--alt" fill="#B78A76" d="M173.63474,132.53613c-19.77919,38.45963-13.6734,84.05106-26.67737,87.68307
						c-9.88466,2.7608-49.68676-58.26537-31.83566-76.82358c3.88921-4.04327,32.38399-22.82735,38.86493-27.01538
						C165.69991,108.81104,184.57893,111.25569,173.63474,132.53613z" />
				</g>
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/ClassicDoggo/Heads.js